import styled, { css } from "styled-components";

import { $dmSansFontFamily, colorsPalettes, mixins } from "@similarweb/styles";

import { TextContainer } from "pro-features/components/core cells/src/CoreWebsiteCell/StyledComponents";
import { CountryCell } from "app/components/React/Table/cells/CountryCell";
import type { IDefaultCellProps } from "app/components/React/Table/cells/DefaultCell";
import { DefaultCell } from "app/components/React/Table/cells/DefaultCell";
import FormattedDateCell from "app/components/React/Table/cells/FormattedDateCell/FormattedDateCell";
import { DomainNameAndIcon } from "app/pages/workspace/common/tableAdditionalColumns";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const tooltipText = css`
    ${mixins.setFontVariant("tooltip", colorsPalettes.carbon[400])};
    font-family: ${$dmSansFontFamily};
`;

export const tooltipBasicTextStyles = css`
    ${tooltipText};

    width: fit-content;
    margin-top: 12px;
    border-radius: 50px;
    background: ${colorsPalettes.carbon["25"]};
    padding: 8px;
    ${mixins.setFontVariant("input2", colorsPalettes.blue["400"])};
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
`;

export const StyledMoreItemsText = styled.div`
    ${tooltipText};

    margin-top: 12px;
    font-weight: 500;
`;

export const StyledDomainNameAndIcon = styled(DomainNameAndIcon)`
    & ${TextContainer} {
        ${tooltipText};

        margin-left: 8px;
    }
`;

export const StyledFormattedDateCell = styled(FormattedDateCell)`
    ${tooltipText};
`;

export const StyledCountryCell = styled(CountryCell)`
    & .countryIcon-container {
        height: auto;
    }

    & .country-text {
        ${tooltipText};
    }
`;

export const StyledDefaultCell = styled(DefaultCell)<IDefaultCellProps>`
    ${tooltipText};
`;

export const StyledAdNetworksDefaultCell = styled(StyledDefaultCell)<IDefaultCellProps>`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const StyledTextCell = styled.div`
    ${mixins.setFontVariant("tooltip", colorsPalettes.carbon[400])};

    font-family: ${$dmSansFontFamily};
    line-height: 15px;
`;

export const StyledScoreWrapper = styled(FlexRow)`
    justify-content: center;
    align-items: center;
`;

export const StyledScoreValue = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin-right: 5px;
    height: 16px;
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
    font-weight: 500;
    background: ${colorsPalettes.bluegrey[200]};
    padding: 4px;
`;
